import { useState } from 'react';

import { SingleUseCardsContainer } from 'modules/single-use-cards';
import { SingleUseCardsEducationalModal } from 'modules/single-use-cards/components/SingleUseCardsEducationalModal';
import { LocalStorageKey } from 'src/core/constants/storage';
import { getLocalItem, setLocalItem } from 'src/core/utils/storage';

import { ErrorBoundary } from '../../common/components/withErrorBoundary';

export const SingleUseCardsPage = () => {
  const [isEducationalModalOpen, setIsEducationalModalOpen] = useState(
    !getLocalItem(LocalStorageKey.SingleUseCardsEducationalModalDismissed),
  );

  const handleEducationalModalClose = () => {
    setLocalItem(
      LocalStorageKey.SingleUseCardsEducationalModalDismissed,
      'true',
    );
    setIsEducationalModalOpen(false);
  };

  return (
    <div className="page__container">
      <ErrorBoundary
        context={{
          team: 'banking-gateway',
          scope: 'single-use-cards',
        }}
      >
        <SingleUseCardsContainer />
      </ErrorBoundary>
      <SingleUseCardsEducationalModal
        isOpen={isEducationalModalOpen}
        onClose={handleEducationalModalClose}
      />
    </div>
  );
};
